import axiosClient from './axiosClient'

const setupLoginApi = {
  create: params => axiosClient.post('setupLogins', params),
  getAll: () => axiosClient.get('setupLogins'),
  getQuotes: () => axiosClient.get('https://api.quotable.io/random'),
  getIslamicQuotes: () => axiosClient.get('https://muhammad-quotes.deno.dev/'),
}

export default setupLoginApi